import React from "react";

import SettingsCard from "../../components/SettingsCard";
import {settingsItems, adminItems} from "../../utils/routes";
import {VsiH4} from "../../styled/App.styled";
import {Row, Col} from "reactstrap";
import { useVsiAppContext } from "../../stores/VsiApp";

export default function Settings() {
    const { user } = useVsiAppContext();
  return <div>
    <VsiH4>Settings <i className={"fa-solid fa-gears"}></i></VsiH4>
    <Row>
      {settingsItems.map((setting, index) => (
          setting.roles.includes(user.role) ?
              <Col xs={12} md={4} key={`setting-card-${setting.title}-${index}`}>
                <SettingsCard {...setting}/>
              </Col> : null
      ))}
    </Row>
    <VsiH4>Admin <i className="fa-solid fa-user-crown"></i></VsiH4>
    <Row>
      {adminItems.map((admin, index) => (admin.roles.includes(user.role) ?
          <Col xs={12} md={4} key={`setting-card-admin-${admin.title}-${index}`}>
            <SettingsCard {...admin}/>
          </Col> : null
      ))}
    </Row>
  </div>;
}
